import { defineChain } from "viem";
import { CUSTOM_DEV_NETWORK, RPC_PROVIDERS } from "config/chains";
import { getContract } from "../../config/contracts";

export const devnet = defineChain({
  id: CUSTOM_DEV_NETWORK,
  name: "Devnet",
  network: "devnet",
  nativeCurrency: {
    name: "ETH",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: RPC_PROVIDERS[CUSTOM_DEV_NETWORK],
    },
    public: {
      http: RPC_PROVIDERS[CUSTOM_DEV_NETWORK],
    },
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "",
    },
  },
  contracts: {
    multicall3: {
      address: getContract(CUSTOM_DEV_NETWORK, "Multicall3") as `0x${string}`,
    },
  },
  testnet: true,
});
